import { WebtrekkWC } from './webtrekk'

if (!customElements.get("rai-webtrekk")) {
  customElements.define("rai-webtrekk", WebtrekkWC);
}
